import { isClient } from "@vfuk/core-helpers";

export const getHostName = () => {
  if (isClient()) {
    return window.location.hostname;
  }
  return undefined;
};
